export interface TrackEventParams {
  event: string
  method?: string
  user_email?: string
  [key: string]: any // for any additional custom parameters
}

export function trackEvent(params: TrackEventParams): void {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(params)
}
